
export const DIGITS_ONLY_PATTERN = /^[0-9]*$/;
export const THIRTEEN_DIGITS_ONLY_PATTERN= /^[0-9]{13}$/;
export const DIGITS_AND_DOT_ONLY_PATTERN = /^[0-9]+([.][0-9]+)?$/;
export const DATE_MM_DD_YYYY_PATTERN = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
export const FLAGS_CDN_URL = 'https://flagcdn.com'
export const OTHER_RELATIONSHIP_CODE="108910008"
